export const selectCurrencyState = (state) => state.common.currencyState;
